export class AsyncTask<T> {
  private promise: Promise<T>
  private stack = new DisposableStack()

  get value() {
    return this.promise
  }

  get canceled() {
    return this.stack.disposed
  }

  constructor(cb: (stack: DisposableStack) => Promise<T>) {
    this.promise = cb(this.stack).finally(() => {
      this.stack.dispose()
    })
  }

  cancel() {
    if (this.canceled) return
    this.stack.dispose()
  }
}
